// extracted by mini-css-extract-plugin
export default {"peopleIcons":"CommunityResultCardContent_peopleIcons__up9Ur","communityResultCardGrid":"CommunityResultCardContent_communityResultCardGrid__CsNrb"};